export default class TabNavigation {
    public initRegistrationNavigation(
        fragmentValidation: (formFragment) => boolean,
        fragmentValidationFailAction: (formFragment) => void = null,
        fragmentValidationSuccessAction: (formFragment) => void = null,
    ): void {
        const prevButtons = jq(".prev-step-btn");
        const nextButtons = jq(".next-step-btn");
        let activeItem;

        prevButtons.on("click", () => {
            activeItem = jq(".nav-link.active");
            activeItem.prev().tab("show");
        });

        nextButtons.on("click", () => {
            activeItem = jq(".nav-link.active");
            const activeTabContent = jq(`${activeItem.attr("data-bs-target")}`);
            if (fragmentValidation(activeTabContent)) {
                activeItem.next().tab("show");
                if (fragmentValidationSuccessAction !== null) {
                    fragmentValidationSuccessAction(activeTabContent);
                }
            } else if (fragmentValidationFailAction !== null) {
                fragmentValidationFailAction(activeTabContent);
            }
        });
    }

}
